export const PAGINATION_ORDER = {
  DESC: 'desc',
  ASC: 'asc',
} as const

export const MOCK_API_PREFIX = '/mockuserdomain'
